<template>
  <div>
    <div class="nav clear-fix" ref="header">
      <div class="pull-left">
<!--        <img class="header-logo" :src="$url.logo" alt="考不倒">-->
      </div>
      <div class="nav-list nav-left pull-left">
        <a style="cursor: pointer; padding-left: 0;line-height: 1.12rem;color: #333" href="https://www.kaobudao.cn" target="_blank">官网首页</a>
<!--        <span v-for="item in router" v-if="item.meta.show_header">{{item.meta.title}}</span>-->
      </div>
      <div class="nav-list nav-right pull-right">
<!--        <span @click="$router.push({name: 'gykf'})">关于课费</span>-->
<!--        <span @click="$router.push({name: 'yhxy'})">服务协议</span>-->
<!--        <span v-if="user.token" @click="$$.routerPush('user')">学习中心</span>-->

<!--        <span class="pc" v-if="index" @click="go1zyy">沪声官网</span>-->
        <span v-if="!index" @click="$$.routerPush('index')">考不倒首页</span>
        <div class="inline-block" v-if="!user.token">
<!--          <span @click="login(false)">登录</span>-->
<!--          <span @click="login(true)">注册</span>-->
        </div>
<!--        <div id="avatar" class="inline-block avatar relative" v-else @mouseenter="drop_Down" @mouseleave="drop_Down">-->
<!--          <img :src="user.user_type.avatar_url" alt="">-->
<!--          <i class="el-icon-arrow-down"></i>-->
<!--          <el-collapse-transition>-->
<!--            <div v-show="dropDown" class="absolute drop-down">-->
<!--&lt;!&ndash;              <p @click="$message.error('暂未开通')">&ndash;&gt;-->
<!--&lt;!&ndash;                账号管理&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p @click="goConsole">&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                <a class="" style="color: #686868" href="http://kbd.1zyy.cn"></a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                控制台&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--              <p @click="login(false)">-->
<!--                切换账号-->
<!--              </p>-->
<!--              <p @click="loginOut()">-->
<!--                退出登录-->
<!--              </p>-->
<!--            </div>-->
<!--          </el-collapse-transition>-->
<!--        </div>-->
      </div>
    </div>
    <login ref="login" @state="loginState"/>
    <div class="empty"></div>
  </div>

</template>

<script>
  import Utils from '@/utils/util'
  import login from '@/components/login/loginDialog';
  export default {
    name: "commonHeader",
    components:{ login },
    data(){
      const auth = this.$auth;
      return{
        // router: router.options.routes,
        dropDown: false,
        // isLogin: false,
        index: true,
        user:{
          user_type: auth.getUserInfo()? JSON.parse(auth.getUserInfo()) : '',
          token: auth.getToken()
        }
      }
    },
    watch:{
      $route(to){
        console.log(to.name == 'index')
        to.name == 'index'? this.index = true : this.index = false;
      }
    },
    mounted() {
      document.addEventListener('DOMContentLoaded', this.DOMContentLoaded, false);
      Utils.$on('login',_=> {
        this.login(false);
      })
      // Utils.$on('isLogin',_=> {
      //   this.isLogin = true;
      // })
    },
    methods:{
      go1zyy(){
        window.location.href = 'https://www.1zyy.cn'
      },
      goConsole(){
        this.$auth.setUserPerson(2);
        location.href = "http://www.kaobudao.cn.cn";
      },
      drop_Down(){
        this.dropDown = !this.dropDown;
      },
      loginOut(){
        this.$confirm('确定要退出账号吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(_ => {
          this.$auth.loginOut(_=>{
            this.$message({
              type: 'success',
              message: '退出登录成功',
              offset: 100,
            });
          });
          this.loginState();
        }).catch(_ => {

        });
      },
      loginState(res){
        if(!res) return this.user.token = false;
        this.user.token = res;
        setTimeout(_=>{
          this.user.user_type = JSON.parse(this.$auth.getUserInfo())
        },200)
      },
      login(v){
        this.$refs.login.dialog(v);
      },
      DOMContentLoaded(){
        let docEl = document.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
          let clientWidth = docEl.clientWidth;
          if (!clientWidth) return;
          if (clientWidth >= 768) {
            docEl.style.fontSize = 50 * (clientWidth / 1600) + 'px';
          }else {
            document.getElementById('body').value = 'name';
            docEl.style.fontSize = 50 * (clientWidth / 320) + 'px';
          }
        };
        let recalcTimer = null;
        let delaycalc = function () {
          window.clearTimeout(recalcTimer);
          recalcTimer = window.setTimeout(recalc,100);
        };
        if (!document.addEventListener) return;
        window.addEventListener(resizeEvt, delaycalc, false);
        document.addEventListener('DOMContentLoaded', delaycalc, false);
        delaycalc();
      }
    }
  }
</script>

<style scoped>
  >>>.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .nav{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    font-size: 0.28rem;
    background: #fff;
    height: 1.12rem;
    padding: 0 1.12rem;
    padding-left: 4rem;
    box-shadow: 0 8px 12px rgb(0,0,0,0.10);
  }
  .header-logo{
    height: 1rem;
    padding-top: 0.06rem;
  }
  .nav-left {
    padding: 0 0.4rem;
  }
  .nav-left span{
    padding-left: 1.2rem;
    line-height: 1.12rem;
    height: 1.12rem;
  }
  .nav-right span, .avatar{
    line-height: 1.12rem;
    height: 1.12rem;
    margin-left: 0.6rem;
    display: inline-block;
    cursor: pointer;
  }
  .avatar:hover{

  }
  .avatar img{
    width: 0.6rem;
    border-radius: 50%;
    margin-right: 0.2rem;
  }
  .drop-down{
    width: 2.5rem;
    background: #eeeeee;
    right: 0;
    text-align: center;
    line-height: 1rem;
    color: #686868;
    font-size: 0.26rem;
    cursor: pointer;
  }
  .drop-down p:hover{
    color: #000;
  }
  .nav-list span:hover{
    color: #00a0e9;
  }
  .empty{
    line-height: 1.12rem;
    height: 1.12rem;
  }
  @media only screen and (max-width: 767px){
    .nav-right span{
      margin: 0 0.2rem;
    }
    .nav{
      padding: 0 0.02rem;
      width: 100%;
      display: none;
      /*display: none;*/
    }
    .empty{
      display: none;
    }
    .nav-list{
      margin: 0 auto;
      float: none;
      text-align: center;
    }
    .pc{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/common/header.vue